import React, { useEffect, useState } from "react";

// Fixed bottom CTA for mobile. Appears after hero; hides when registration in view.
const MobileBottomCTA = ({ onRegister }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const pastHero = window.scrollY > 480;
      const reg = document.getElementById("register");
      let regInView = false;
      if (reg) {
        const r = reg.getBoundingClientRect();
        regInView = r.top < window.innerHeight && r.bottom > 0;
      }
      setVisible(pastHero && !regInView);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="lg:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 transition-transform duration-300"
      style={{
        transform: visible ? "translateY(0)" : "translateY(120%)",
        background: "linear-gradient(to top, rgba(7,21,36,0.96), rgba(7,21,36,0))",
      }}
    >
      <button
        data-testid="mobile-bottom-cta"
        onClick={onRegister}
        className="w-full h-14 rounded-2xl bg-[#F7B838] text-[#071524] text-base font-semibold shadow-[0_10px_30px_rgba(7,21,36,0.4)] active:scale-[0.99]"
      >
        Reserve My Complimentary Seat
      </button>
    </div>
  );
};

export default MobileBottomCTA;
